export default __webpack_public_path__ + "static/media/google_doc_icon.241636fc.png";